export default "__VITE_ASSET__C2v6jXk8__"